export class LanguageService {
  public static getCurrentLanguage(): string {
    return document.querySelector('html')?.getAttribute('lang') ?? '';
  }
}
